import template from './spendings.html';
import controller from './spendings.controller';

let spendingsComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default spendingsComponent;
